import * as React from 'react';
import * as Wouter from 'wouter';
import { useRouter } from '~/Router/useRouter';
var Link = function (_a) {
    var children = _a.children, _b = _a.newTarget, newTarget = _b === void 0 ? false : _b, subdomain = _a.subdomain, to = _a.to;
    var _c = useRouter(), buildLink = _c[1];
    var link = buildLink(to, subdomain);
    if (newTarget) {
        return React.cloneElement(children, {
            href: link.to,
            onClick: function (event) {
                event.preventDefault();
                window.open(event.currentTarget.href, 'new');
            },
        });
    }
    return link.isRelative ? (<Wouter.Link to={to}>{children}</Wouter.Link>) : (React.cloneElement(children, { href: link.to }));
};
Link.displayName = 'Router.Link';
var Redirect = function (_a) {
    var data = _a.data, replace = _a.replace, subdomain = _a.subdomain, to = _a.to;
    var redirect = useRouter()[0];
    React.useLayoutEffect(function () {
        redirect(to, subdomain, replace, data);
    }, []);
    return null;
};
Redirect.displayName = 'Router.Redirect';
// tslint:disable-next-line: no-any
var Route = /** @class */ (function () {
    function Route(Target, path, createLink) {
        this.Link = function (props) { return <Link to={createLink(props)} {...props}/>; };
        this.Link.displayName = 'Route.Link';
        this.path = path;
        this.Redirect = function (props) { return <Redirect to={createLink(props)} {...props}/>; };
        this.Redirect.displayName = 'Route.Redirect';
        this.Target = Target;
        this.useRedirect = function () {
            // eslint-disable-next-line react-hooks/rules-of-hooks
            var redirect = useRouter()[0];
            return function (props) {
                redirect(createLink(props), props.subdomain, props.replace, props.data);
            };
        };
    }
    return Route;
}());
export { Route };
